module.exports = __webpack_public_path__ + "img/settings_active.c3337106.svg";